/* Legacy SUCCESS badge; independent countdown/buttons remain owned by Crowdfunder. */
(function () {
  function update() {
    var widget = document.querySelector('.crowdfunder-widget:not(.simple)');
    var percent = widget && widget.querySelector('.cf-percent-text');
    var badge = document.querySelector('.success-point');
    if (percent && badge && Number(percent.textContent) > 100) badge.classList.add('active');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
  document.addEventListener('shopify:section:load', update);
})();
